/**
 * Redirect user to same page on HTTPS
 */
export function httpRedirect() {
  if (location.protocol !== 'https:') {
    location.href =
      'https:' + window.location.href.substring(window.location.protocol.length)
  }
}
